import gql from 'graphql-tag';

export const getGasReleaseTypeGrades = gql`
  query getGasReleaseTypeGrades {
    getGasReleaseTypeGrades {
      id
      name
    }
  }
`;
